<ng-container *ngIf="channel === ''">
  <div class="max-sm:p-3">
    <h1
      class="font-inter-700 text-blue text-24 max-sm:text-16 pb-3 max-sm:pb-1"
    >
      {{ "TopNews" | translate }}
    </h1>
    <nz-skeleton
      [nzActive]="true"
      [nzLoading]="loader"
      *ngIf="loader"
      class="py-2"
    ></nz-skeleton>

    <ng-container *ngIf="!loader && topNews.length > 0">
      <!-- <div
        [routerLink]="[
          '/noticias/',
          topNews[0].news_Bullet,
          topNews[0].newsUrl
        ]"
        class="mb-5 aspect-news relative cursor-pointer flex flex-col justify-end bg-cover bg-center text-white rounded-8 p-12 max-sm:p-5 max-xl:p-8"
        [ngStyle]="{
          'background-image': 'url(' + topNews[0].news_Images[0] + ')'
        }"
      >
        <div class="absolute inset-0 bg-black bg-opacity-40 rounded-8"></div>
        <div class="z-10 max-w-[700px]">
          <div
            class="font-inter-700 text-26 max-sm:text-18 pb-5 max-sm:pb-2 hover:underline"
          >
            {{ topNews[0].news_HeadLine }}
          </div>
          <div class="flex gap-10 font-roboto-400 text-12 max-sm:text-10">
            <span>{{
              genericServices.getDisplayDate(topNews[0].match_date)
            }}</span>
            <span>{{ topNews[0].news_Bullet }}</span>
          </div>
        </div>
      </div> -->

      <div
        [routerLink]="[
          '/noticias/',
          topNews[0].news_Bullet,
          topNews[0].newsUrl
        ]"
        class="mb-5 aspect-news relative cursor-pointer flex flex-col justify-end text-white rounded-8 p-12 max-sm:p-5 max-xl:p-8"
        [ngStyle]="{
          'background-image':
            'linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(' +
            topNews[0].news_Images[0] +
            ')',
          'background-size': 'cover',
          'background-position': 'center'
        }"
      >
        <div class="max-w-[700px]">
          <div
            class="font-inter-700 text-26 max-sm:text-18 pb-5 max-sm:pb-2 hover:underline"
          >
            {{ topNews[0].news_HeadLine }}
          </div>
          <div class="flex gap-10 font-roboto-400 text-12 max-sm:text-10">
            <span>{{
              genericServices.getDisplayDate(topNews[0].match_date)
            }}</span>
            <span>{{ topNews[0].news_Bullet }}</span>
          </div>
        </div>
      </div>

      <div class="w-full max-w-[800px]">
        <div class="flex overflow-x-auto hidden-scrollbar gap-4">
          <div
            class="cursor-pointer min-w-[300px] max-sm:min-w-[200px]"
            *ngFor="let notice of this.topNews.slice(1)"
            [routerLink]="['/noticias/', notice.news_Bullet, notice.newsUrl]"
          >
            <img
              alt="news-banner"
              class="h-[170px] max-sm:h-[100px] w-full rounded-8 object-cover"
              [src]="notice.news_Images[0]"
            />
            <div
              class="font-inter-500 text-20 max-sm:text-14 py-4 max-sm:py-2 hover:underline"
            >
              {{ notice.news_HeadLine }}
            </div>
            <div class="flex gap-1 text-grey-2 max-sm:text-10">
              <span>{{
                genericServices.getDisplayDate(notice.match_date)
              }}</span>
              <span>{{ notice.news_Bullet }}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!loader && arraysNotice.length > 0">
      <div
        class="font-inter-700 text-24 max-sm:text-16 pt-9 max-sm:pt-5 pb-3 max-sm:pb-1"
      >
        {{ "MoreNews" | translate }}
      </div>

      <div class="flex flex-col gap-7 max-sm:gap-4">
        <div
          class="flex gap-3 cursor-pointer max-[450px]:flex-col"
          [routerLink]="['/noticias/', notice.news_Bullet, notice.newsUrl]"
          *ngFor="
            let notice of this.arraysNotice
              | slice : 0 : (moreNews ? 6 : arraysNotice.length)
          "
        >
          <img
            alt="news-banner"
            class="max-w-[290px] h-[155px] max-sm:max-w-[190px] max-sm:h-[105px] max-[450px]:max-w-[unset] max-[450px]:h-[unset] max-[450px]:aspect-news w-full rounded-7 object-cover"
            [src]="notice.news_Images[0]"
          />
          <div class="font-inter-500 text-20 max-sm:text-14">
            {{ notice.news_HeadLine }}<br /><span
              class="font-sofia-sans-400 text-14 max-sm:text-10 text-grey-2"
              >{{ genericServices.getDisplayDate(notice.match_date, true) }}
              <span class="p-2"></span>
              {{ notice.news_Bullet }}</span
            >
          </div>
          <!-- <img alt="logo" class="ml-auto" [src]="urlIcon + 'save-active.svg'" /> -->
        </div>
      </div></ng-container
    >

    <div class="flex justify-center" *ngIf="moreNews">
      <button
        class="flex gap-1 items-center text-red-2 p-3 font-roboto-500"
        (click)="moreNews = !moreNews"
      >
        <span>{{ "MoreNews" | translate }}</span>
        <img alt="add" [src]="urlIMG + 'icons/add.svg'" />
      </button>
    </div>
  </div>
</ng-container>
<app-news-detail *ngIf="channel !== ''" [channel]="channel"></app-news-detail>
